@if (region) {
    <div class="region-card">
        <div class="region-card__header">
            @if (region.imageUrl; as imageUrl) {
                <figure>
                    <img [src]="imageUrl | safeUrl" alt="country-image">
                </figure>
            }
        </div>
        <div class="region-card__content">
            <h3>{{ region.name }}</h3>
        </div>
        <div class="region-card__footer">
            <button [routerLink]="['/', countryName, region.name]" class="region-card__about btn-default btn-border">
                About
            </button>
            <button class="region-card__cities btn-default btn-border"
                    (click)="toggleView()"
                    [class.btn-border-active]="isViewCities">
                {{ isViewCities ? 'Close cities' : 'View cities' }}
            </button>
        </div>
    </div>
}
